import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BlockquoteIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 6.09523C1 4.38578 2.45507 3 4.25 3C6.04493 3 7.50003 4.38578 7.50003 6.09523L7.50003 6.14871C7.50011 7.29952 7.5002 8.45945 7.15705 9.57058C6.797 10.7365 6.07643 11.8089 4.71855 12.8435C4.3951 13.0899 3.92313 13.0399 3.66438 12.7319C3.40562 12.4239 3.45806 11.9744 3.78151 11.7279C4.92363 10.8577 5.45306 10.0254 5.718 9.16748C5.75447 9.04939 5.78623 8.93011 5.81388 8.80921C5.34991 9.05222 4.81691 9.19046 4.25 9.19046C2.45507 9.19046 1 7.80468 1 6.09523Z"
		></path>
		<path
			fill="currentColor"
			d="M8.5 6.09523C8.5 4.38578 9.95507 3 11.75 3C13.5449 3 15 4.38578 15 6.09523L15 6.14871C15.0001 7.29952 15.0002 8.45945 14.6571 9.57058C14.297 10.7365 13.5764 11.8089 12.2185 12.8435C11.8951 13.0899 11.4231 13.0399 11.1644 12.7319C10.9056 12.4239 10.9581 11.9744 11.2815 11.7279C12.4236 10.8577 12.9531 10.0254 13.218 9.16748C13.2545 9.04939 13.2862 8.93011 13.3139 8.80921C12.8499 9.05222 12.3169 9.19046 11.75 9.19046C9.95507 9.19046 8.5 7.80468 8.5 6.09523Z"
		></path>
	</svg>
))
